/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_Rate_HintInputs */

const en_lesson_rate_hint = /** @type {(inputs: Lesson_Rate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`— this lesson only`)
};

const he_lesson_rate_hint = /** @type {(inputs: Lesson_Rate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`— לשיעור זה בלבד`)
};

/**
* | output |
* | --- |
* | "— this lesson only" |
*
* @param {Lesson_Rate_HintInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_rate_hint = /** @type {((inputs?: Lesson_Rate_HintInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_Rate_HintInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_rate_hint(inputs)
	return he_lesson_rate_hint(inputs)
});